import { render, staticRenderFns } from "./ExploreUsers.vue?vue&type=template&id=f2533cb2&scoped=true&"
import script from "./ExploreUsers.vue?vue&type=script&lang=js&"
export * from "./ExploreUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2533cb2",
  null
  
)

export default component.exports